<div class="capabilities-page">
  <section class="capabilities-hero animate-fade-in-up" aria-label="Capabilities">
    <div class="capabilities-hero__container">
      <div class="capabilities-hero__head">
        <div class="capabilities-hero__eyebrow">Capabilities</div>
        <h1 class="capabilities-hero__title">
          Empowering Your <br class="capabilities-hero__title-break" />Digital Future.
        </h1>
        <p class="capabilities-hero__copy">
          From bespoke cloud migration architectures to ironclad enterprise security frameworks—Reve Cloud
          delivers deep-tech consulting and infrastructure tailored explicitly for your organizational
          success.
        </p>
      </div>

      <div class="services-grid">
        @for (service of services; track service) {
          <a class="service-card" [routerLink]="['/services', service.id]"
            [attr.aria-label]="'View ' + service.name + ' service details'" (click)="scrollToTop()">
            <div class="service-card__icon-wrap">
              <iconify-icon [icon]="service.icon" class="service-card__icon"></iconify-icon>
            </div>
            <h2 class="service-card__title">{{ service.name }}</h2>
            <p class="service-card__copy">{{ service.desc }}</p>
          </a>
        }
      </div>
    </div>
  </section>

  <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
  <div class="contact-section__container">
    <div class="contact-section__grid">
      <div>
        <div class="contact-section__eyebrow">Connect</div>
        <div class="contact-section__title">Discover the future of applied AI.</div>
        <div class="contact-section__copy">
          Connect with our delivery experts to audit your topology and map your enterprise integration
          roadmap.
        </div>
      </div>

      <div class="contact-card">
        <div class="contact-card__corner" aria-hidden="true"></div>
        <div class="contact-card__title">Direct Inquiry</div>

        <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div>Request securely logged. Our architecture team will reach out within one business day.
          </div>
        </div>

        <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="contact-form__field">
            <input type="text" formControlName="name" placeholder="Full Name" />
          </div>

          <div class="contact-form__row">
            <div class="contact-form__field">
              <input type="email" formControlName="email" placeholder="Corporate Email" />
            </div>
            <div class="contact-form__field">
              <input type="text" formControlName="company" placeholder="Organization" />
            </div>
          </div>

          <div class="contact-form__field">
            <textarea rows="3" formControlName="message"
            placeholder="Brief context of operational challenges..."></textarea>
          </div>

          <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
            class="contact-form__submit">
            <span *ngIf="!isSubmitting">Transmit Request</span>
            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Encrypting...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section> -->
</div>
